import axios from 'axios';

import errorMessage from 'Store/actions/errorMessage';
import { gameTypeConverter, SANS_TOPU } from 'Store/constants/sportTypes';
import {
  TOGGLE_CG_NUMBER,
  TOGGLE_CG_EXTRA_NUMBER,
  SET_AUTO_CG_SELECTIONS,
  SET_CG_ACTIVE_COLUMN,
  CLEAR_CG_COLUMN,
  TOGGLE_CG_SLIP,
  CLEAR_CG_SLIP,
  PLAY_CHANCE_GAMES_COUPON_REQUEST,
  PLAY_CHANCE_GAMES_COUPON_SUCCESS,
  PLAY_CHANCE_GAMES_COUPON_FAILURE,
  SET_CHANCE_GAMES_PLAY_DATA_FROM_LOCAL_STORAGE,
  GENERATE_CG_COUPONS_REQUEST,
  GENERATE_CG_COUPONS_SUCCESS,
  GENERATE_CG_COUPONS_FAILURE,
  SET_CG_GENERATED_COLUMNS_TO_SLIP
} from 'Store/constants';
import { openModal, closeModal } from 'Store/actions';
import { loadStateFromIndexedDB } from 'Utils/manageIndexedDB';
import { generateRandomNumbers, generateRandomNumber, apiURLMapping } from 'Pages/ChanceGames/cgUtils';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const setCGPlayDataFromLocalStorage = () => dispatch => {
  loadStateFromIndexedDB('cgPlay', data => {
    dispatch({
      type: SET_CHANCE_GAMES_PLAY_DATA_FROM_LOCAL_STORAGE,
      payload: data
    });
  });
};

export const generateCoupons = (gameType, columnCount) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GENERATE_CG_COUPONS_REQUEST,
      payload: { gameType }
    });

    const res = await axios.post(`${API_GATEWAY}/mobile/digital-lottery/coupons/generate`, {
      gameType: apiURLMapping[gameType],
      columnCount
    });

    dispatch({
      type: GENERATE_CG_COUPONS_SUCCESS,
      payload: res.data.coupons
    });

    const selections = getState().chanceGames.cgPlay[gameTypeConverter[gameType]].selections;

    if (selections.some(column => column.selection.length || column.extraSelection.length)) {
      dispatch(openModal('machinePlayAgreementModal'));
    } else {
      dispatch(setCGColumnsToSlip(gameType));
      dispatch(toggleCGSlip());
    }
  } catch (e) {
    dispatch({
      type: GENERATE_CG_COUPONS_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });
  }
};

export const setCGColumnsToSlip = (gameType, columns) => (dispatch, getState) => {
  try {
    const coupons = getState().chanceGames.cgPlay.generatedCoupons?.data;
    const maxColumnCount = getState().chanceGames.cgRules.data?.maxColumnCount;
    const maxCouponCount = getState().chanceGames.cgRules.data?.maxCouponCount;
    const totalColumnCount = maxColumnCount * maxCouponCount;

    dispatch({
      type: SET_CG_GENERATED_COLUMNS_TO_SLIP,
      payload: { gameType, coupons, totalColumnCount }
    });
  } catch (e) {
    //console.log('Oluşturulan kuponlar eklenemedi.');
  }
};

const createPlayRequest = (createdColumnsRequest, columns, maxColumnCount) => {
  let columnsRequest = [];

  if (createdColumnsRequest) {
    columnsRequest = [{ columns: createdColumnsRequest }];
  } else {
    // Before play action, seperate coupons based on max column number.

    if (columns.length < maxColumnCount) {
      let modifiedColumns = {};

      columns.forEach((column, index) => {
        modifiedColumns = {
          ...modifiedColumns,
          [index + 1]: {
            selections: column.selection,
            optionals: column.extraSelection
          }
        };
      });

      columnsRequest.push({ columns: modifiedColumns });
    } else {
      let columnsObj = {};

      columns.forEach((column, index) => {
        let key = index + 1;

        if (key % maxColumnCount !== 0) {
          columnsObj = {
            ...columnsObj,
            [key % maxColumnCount]: {
              selections: column.selection,
              optionals: column.extraSelection
            }
          };
        }

        if (key % maxColumnCount === 0 || key === columns.length) {
          if (key % maxColumnCount === 0) {
            columnsObj = {
              ...columnsObj,
              [maxColumnCount]: {
                selections: column.selection,
                optionals: column.extraSelection
              }
            };
          }

          columnsRequest.push({ columns: columnsObj });
          columnsObj = {};
        }
      });
    }
  }

  return columnsRequest;
};

export const playCGCoupon = (gameType, columns, createdColumnsRequest) => async (dispatch, getState) => {
  try {
    dispatch({
      type: PLAY_CHANCE_GAMES_COUPON_REQUEST
    });

    dispatch(openModal('couponPlayingModal'));

    const maxColumnCount = getState().chanceGames.cgRules.data.maxColumnCount;
    const playRequest = createPlayRequest(createdColumnsRequest, columns, maxColumnCount);

    const res = await axios.post(`${API_GATEWAY}/mobile/digital-lottery/coupons/play`, {
      gameType: apiURLMapping[gameType],
      coupons: playRequest
    });

    dispatch({
      type: PLAY_CHANCE_GAMES_COUPON_SUCCESS,
      payload: res.data
    });

    if (!res.data.successCount && !res.data.couponList.length) {
      dispatch(openModal('couponsWaitingModal'));
    } else {
      dispatch(openModal('playCGSuccessModal'));
    }

    dispatch(closeModal('couponPlayingModal'));
  } catch (e) {
    dispatch(closeModal('couponPlayingModal'));
    dispatch({
      type: PLAY_CHANCE_GAMES_COUPON_FAILURE,
      payload: e.response && e.response.data || errorMessage,
    });

    if (e.response?.data) {
      switch (e.response.data.code) {
        case 4004:
          dispatch(openModal('cgInsufficientFundsModal'));
          break;
        default:
          dispatch(openModal('playCGCouponFailModal'));
      }
    }
  }
};

export const toggleCGNumber = (number, gameType, isExtraSelection = false) => (dispatch, getState) => {
  const rulesData = getState().chanceGames.cgRules.data;
  const limit = isExtraSelection ? rulesData.extra.maxDigitForColumn : rulesData.maxDigitForColumn;

  dispatch({
    type: isExtraSelection ? TOGGLE_CG_EXTRA_NUMBER : TOGGLE_CG_NUMBER,
    payload: { number, gameType, isExtraSelection, limit }
  });
};

export const setCGActiveColumn = (columnName, gameType) => dispatch => {
  dispatch({
    type: SET_CG_ACTIVE_COLUMN,
    payload: { columnName, gameType }
  });
};

export const clearCGColumn = (columnName, gameType) => (dispatch, getState) => {
  const stateKey = gameTypeConverter[gameType];
  const closeSlip = getState().chanceGames.cgPlay[stateKey]?.selections.filter(item => item.selection.length || item.extraSelection.length).length === 1 && getState().chanceGames.cgSlip.isOpen;

  dispatch({
    type: CLEAR_CG_COLUMN,
    payload: { columnName, gameType }
  });

  if (closeSlip) {
    dispatch(toggleCGSlip());
  }
};

export const toggleCGSlip = () => dispatch => {
  dispatch({
    type: TOGGLE_CG_SLIP
  });
};

export const clearCGSlip = gameType => (dispatch, getState) => {
  dispatch({
    type: CLEAR_CG_SLIP,
    payload: { gameType }
  });

  if (getState().chanceGames.cgSlip.isOpen) {
    dispatch(toggleCGSlip());
  }
};

export const setAutoCGSelections = autoSelectionParams => (dispatch, getState) => {
  const {
    gameType,
    columnName,
    maxDigitForColumn,
    startNumber,
    endNumber,
    extraStartNumber,
    extraEndNumber
  } = autoSelectionParams;

  const activeColumn = getState().chanceGames.cgPlay[gameTypeConverter[gameType]].selections.find(column => column.columnName === columnName);
  let newColumn = activeColumn;

  switch (gameType) {
    case SANS_TOPU: {
      const selection = generateRandomNumbers(activeColumn.selection, startNumber, endNumber, maxDigitForColumn);
      const extraSelection = generateRandomNumber(extraStartNumber, extraEndNumber);

      newColumn = {
        ...activeColumn,
        selection,
        extraSelection
      };
      break;
    }
    default: {
      const selection = generateRandomNumbers(activeColumn.selection, startNumber, endNumber, maxDigitForColumn);

      newColumn = {
        ...activeColumn,
        selection
      };
      break;
    }
  }

  dispatch({
    type: SET_AUTO_CG_SELECTIONS,
    payload: { gameType, columnName, newColumn }
  });

  dispatch(setCGActiveColumn(columnName, gameType));
};
